import { FC } from 'react';
import style from './unit-builder-modal.module.scss';

interface RegionPlaceholderProps {
  /** What fills this pane. */
  label: string;
  /** Which component fills it, and where that component lives. */
  source: string;
  /**
   * The pieces nested inside this pane, in top-to-bottom order. The mock puts
   * them inside the pane's own component rather than exposing them to the
   * shell, so they are listed here to show where each one lands.
   */
  parts?: string[];
}

/**
 * Stands in for a Unit Builder pane until its real component is wired.
 *
 * @param {RegionPlaceholderProps} props - What the pane is, and what nests inside it.
 * @return {JSX.Element} The placeholder.
 */
export const RegionPlaceholder: FC<RegionPlaceholderProps> = ({
  label,
  source,
  parts,
}) => (
  <div className={style.placeholder} data-testid={`placeholder-${label}`}>
    <p className={style.placeholderLabel}>{label}</p>
    <p className={style.placeholderSource}>{source}</p>
    {parts && parts.length > 0 && (
      <ol className={style.placeholderParts}>
        {parts.map((part) => (
          <li key={part}>{part}</li>
        ))}
      </ol>
    )}
  </div>
);
